import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-561cde56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "analysisEchars" }
const _hoisted_2 = { class: "analysisEchars_left" }
const _hoisted_3 = { class: "echars" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "analysisEchars_right" }
const _hoisted_6 = { class: "analysisEchars_right_tabs" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["id"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["id"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["id"]

import { onMounted, ref, reactive } from 'vue';
import * as echarts from 'echarts';
import type { itemconfig } from '@/views/dataCenter/Questionnaire/components/type';
interface item_config {
  dataSource: itemconfig;
  fill_count: number;
  id: number;
  type: number;
  structure: [
    {
      name: string;
      prop: number;
      value: number;
      quest_items_id: number;
    }
  ];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AnalysisEchars',
  props: {
    item_config: null
  },
  setup(__props: any) {

const props = __props as { item_config: item_config };



// 左侧图表数据
const data = [
  { name: '选项一', prop: '38%', quantity: '38', color: '#00ccb0', id: 0 },
  { name: '选项二', prop: '100%', quantity: '100', color: '#5654F5', id: 1 },
  { name: '选项三', prop: '95%', quantity: '94', color: '#FF875A', id: 2 },
  { name: '选项四', prop: '60%', quantity: '60', color: '#FE6867', id: 3 },
  { name: '选项五', prop: '50%', quantity: '50', color: '#F554AF', id: 4 },
];
// tab切换事件
const tabs = ref(0);
const getTabs = (id: number) => {
  tabs.value = id;
  setTimeout(() => {
    id == 0 ? pieEcharts() : id == 1 ? barEcharts() : lineEcharts();
  }, 100);
};

const leftLineChart = ref(`leftLineCharts${Date.now() + Math.random()}`);
const pieChart = ref(`pieChart${Date.now() + Math.random()}`);
const barChart = ref(`barChart${Date.now() + Math.random()}`);
const lineChart = ref(`lineChart${Date.now() + Math.random()}`);

const fillingRate = reactive<any[]>([]); // 填写率
const fillingQuantity = reactive<any[]>([]); // 填写量
const yAxisName = reactive<any[]>([]);
const pieData = reactive<any[]>([]);
props.item_config.structure.forEach((item: any) => {
  fillingRate.push(((item.value / props.item_config.fill_count) * 100).toFixed(0));
  fillingQuantity.push(item.value);
  yAxisName.push(item.name);
  pieData.push(item);
});

// 左侧柱状图
const initLeftEcharts = () => {
  const leftLineCharts: HTMLElement = document.getElementById(leftLineChart.value) as HTMLElement;
  const leftLineChartsSet = echarts.init(leftLineCharts);
  leftLineChartsSet.setOption(
    {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        left: 10,
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01],
      },
      yAxis: {
        type: 'category',
        data: yAxisName,
      },
      series: [
        {
          name: '填写率(%)',
          type: 'bar',
          data: fillingRate,
          barWidth: '18px',
          itemStyle: {
            color: '#00CCB0',
          },
        },
        {
          name: '填写量',
          type: 'bar',
          itemStyle: {
            color: '#7583FF',
          },
          barWidth: '18px',
          data: fillingQuantity,
        },
      ],
    },
    true
  );

  window.onresize = function () {
    leftLineChartsSet.resize();
  };
};

// 饼图
const pieEcharts = () => {
  const pieCharts: HTMLElement = document.getElementById(pieChart.value) as HTMLElement;
  const pieChartSet = echarts.init(pieCharts);
  pieChartSet.setOption({
    tooltip: {
      trigger: 'item',
    },
    legend: {
      top: '10%',
      type: 'scroll',
      left: 'left',
      itemGap: 20,
    },
    series: [
      {
        center: ['40%', '50%'],
        name: '填写量',
        type: 'pie',
        radius: [60, 100],
        itemStyle: {
          color: function (pieData: any) {
            var colorList = [
              '#FFBD66',
              '#0C84C6',
              '#61DDAA',
              '#00CCB0',
              '#65789B',
              '#5B8FF9',
              '#FF875B',
              '#FF6868',
              '#775BFF',
              '#4C84FF',
              '#505D6F',
            ];
            return colorList[pieData.dataIndex];
          },
        },
        data: pieData,
      },
    ],
  });
};

// 柱状图
const barEcharts = () => {
  const barCharts: HTMLElement = document.getElementById(barChart.value) as HTMLElement;
  const barChartSet = echarts.init(barCharts);
  barChartSet.setOption({
    tooltip: {
      trigger: 'item',
    },
    xAxis: {
      type: 'category',
      data: yAxisName,
      axisLabel: {
        color: '#999999',
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#999999',
      },
    },
    barWidth: 10,
    itemStyle: {
      emphasis: {
        borderRadius: 10,
      },
    },
    series: [
      {
        name: '填写量',
        itemStyle: {
          borderRadius: [10, 10, 0, 0],
          color: function (pieData: any) {
            var colorList = [
              '#FFBD66',
              '#0C84C6',
              '#61DDAA',
              '#00CCB0',
              '#65789B',
              '#5B8FF9',
              '#FF875B',
              '#FF6868',
              '#775BFF',
              '#4C84FF',
            ];
            return colorList[pieData.dataIndex];
          },
        },
        data: pieData,
        type: 'bar',
      },
    ],
    grid: {
      left: '0',
      right: '0',
      bottom: '15%',
      top: '15%',
      containLabel: true,
    },
  });
};

// 折线图
const lineEcharts = () => {
  const lineCharts: HTMLElement = document.getElementById(lineChart.value) as HTMLElement;
  const lineChartSet = echarts.init(lineCharts);
  lineChartSet.setOption({
    tooltip: {
      trigger: 'item',
    },
    xAxis: {
      type: 'category',
      data: yAxisName,
      axisLabel: {
        color: '#999999',
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#999999',
      },
    },
    series: [
      {
        name: '填写量',
        data: fillingQuantity,
        type: 'line',
        symbolSize: 10,
        barGap: '80%',
        lineStyle: {
          color: '#00CCB0',
          width: 4,
        },
        itemStyle: {
          borderWidth: 6,
          color: function (fillingQuantity: any) {
            var colorList = [
              '#FFBD66',
              '#0C84C6',
              '#61DDAA',
              '#00CCB0',
              '#65789B',
              '#5B8FF9',
              '#FF875B',
              '#FF6868',
              '#775BFF',
              '#4C84FF',
            ];
            return colorList[fillingQuantity.dataIndex];
          },
        },
      },
    ],
    legend: {
      itemGap: 60,
    },
    grid: {
      left: '0',
      right: '0',
      bottom: '15%',
      top: '15%',
      containLabel: true,
    },
  });
};

onMounted(() => {
  initLeftEcharts();
  pieEcharts();
  // barEcharts();
  // lineEcharts();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "analysisEchars_right_pieChart",
          id: leftLineChart.value,
          style: {"min-width":"350px","max-width":"800px","height":"500px"}
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["tabs_radio", tabs.value == 0 ? 'tabs_radios' : '']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (getTabs(0)))
        }, "饼图", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tabs_radio", tabs.value == 1 ? 'tabs_radios' : '']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (getTabs(1)))
        }, "柱状图", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tabs_radio", tabs.value == 2 ? 'tabs_radios' : '']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (getTabs(2)))
        }, "折线图", 2)
      ]),
      (tabs.value == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "analysisEchars_right_pieChart",
              id: pieChart.value,
              style: {"width":"500px","height":"500px"}
            }, null, 8, _hoisted_8)
          ]))
        : _createCommentVNode("", true),
      (tabs.value == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "analysisEchars_right_pieChart",
              id: barChart.value,
              style: {"width":"500px","height":"500px"}
            }, null, 8, _hoisted_10)
          ]))
        : _createCommentVNode("", true),
      (tabs.value == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "analysisEchars_right_pieChart",
              id: lineChart.value,
              style: {"width":"500px","height":"500px"}
            }, null, 8, _hoisted_12)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})